import { useCurrentUser } from "@/hooks/useCurrentUser";

const CREATE_ROLES = ["App.ADMIN"] as const;
/** Cross-provider Known Mappings (global page / PM dropdown) — matches can_view_all_providers. */
const GLOBAL_KNOWN_MAPPINGS_ROLES = ["App.ADMIN", "App.PROVIDER_VIEWER"] as const;
/** Global Ingestion History — App.ADMIN only */
const GLOBAL_INGESTION_HISTORY_ROLES = ["App.ADMIN"] as const;

export interface ProviderPermissions {
  /** provider.write — create new providers (App.ADMIN only) */
  canCreateProvider: boolean;
  /**
   * Global Known Mappings page (all providers) — App.ADMIN or App.PROVIDER_VIEWER.
   * Per-provider Known Mappings tabs remain available to other roles.
   */
  canViewGlobalKnownMappings: boolean;
  /**
   * Global Ingestion History page (all providers) — App.ADMIN only.
   * Per-provider Ingestion History tabs remain available to other roles.
   */
  canViewGlobalIngestionHistory: boolean;
}

/** Maps UI provider-management affordances to backend App.* role rules. */
export function useProviderPermissions(): ProviderPermissions {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    return {
      canCreateProvider: false,
      canViewGlobalKnownMappings: false,
      canViewGlobalIngestionHistory: false,
    };
  }

  const { roles } = currentUser;
  return {
    canCreateProvider: CREATE_ROLES.some((r) => roles.includes(r)),
    canViewGlobalKnownMappings: GLOBAL_KNOWN_MAPPINGS_ROLES.some((r) => roles.includes(r)),
    canViewGlobalIngestionHistory: GLOBAL_INGESTION_HISTORY_ROLES.some((r) => roles.includes(r)),
  };
}
